/**
 * @file 必須項目設定
 */
'use strict';

/**
 * @classname FormRequiredRestNum
 * @classdesc 必須項目設定
 */
export default class FormRequiredRestNum {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('FormRequiredRestNum.constructor');
		this._$e = $e;
		this._controller = controller;
		this._element = $e.prop('tagName').toLowerCase();
		this._type = $e.attr('type') || null;
		console.log(`check ${this._$e.attr('name')}`);
		if(this._element === 'select'){
			this._$e.on('change', () => this.count());
		}else if(this._type === 'checkbox'){
			this._$e.on('click', () => this.count());
		}else {
			this._$e.on('blur', () => this.count());
		}
		// if($('#trigger1')[0]){
		// 	$('#agree').on('click', () => this.count());
		// }
		if($('#agree')[0]){
			$('#agree').on('click', () => this.count());
		}
		//this.count();
	};


	/**
	 * 必須確認
	 *
	 * @memberof FormRequiredRestNum
	 * @return {undefined}
	 */
	count() {
		console.log('FormRequiredRestNum.count');
		setTimeout(() => {
			let rest = 0;
			$('.required').each((idx, e) => {
				const $e = $(e);
				if($e.val() === '' || $e.hasClass('is-invalid')) rest ++;
			});

			// チェックボックス
			if($('.input-checkbox-btn')[0]){
				let cnt = false;
				$(`.input-checkbox-btn`).each((idx, e) => {
					const $e =  $(e);
					if($e.prop('checked')) cnt = true;
				});
				console.log(`cnt: ${cnt}`);
				if(!cnt) rest ++;
			}

			console.log(`${this._element} / ${this._$e.attr('id')}`);
			console.log(rest);
			$('.text--rest-num').text(rest);

			if($('#agree')[0]){
				//if(rest === 0 && $('#agree').prop('checked')){
				// if($('#agree').prop('checked')){
				// 	$('.btn--submit[data-form]').removeClass('disabled');
				// }else{
				// 	$('.btn--submit[data-form]').addClass('disabled');
				// }
			}else{
				if(rest === 0){
					$('.btn--submit[data-form]').removeClass('disabled');
				}else{
					$('.btn--submit[data-form]').addClass('disabled');
				}
			}
		}, 200);
	};

}
